<div app-topbar class="layout-topbar">
	<div class="layout-topbar" style="margin-right: 0px !important">
		<button type="button" class="mobile-menu-toggle" appMobileSidebarToggler aria-label="Toggle menu">
			<i class="pi pi-bars"></i>
		</button>
		<div style="min-width: 200px; height: 100%">
			@if(logo || portale) {
			<a class="app-logo" routerLink="/">
				@if(logo){
				<img style="max-width: 180px; max-height: 60px" alt="app logo" [src]="sanitizer.bypassSecurityTrustResourceUrl(logo)" />
				} @else if(portale) {
				<span class="app-name">{{ portale }}</span> }
			</a>
			}
		</div>

		<div style="flex-grow: 1; display: flex; justify-content: flex-start; flex-direction: row; gap: 20px">
			<!--@if(active_portal_name){
			<div id="portal_selection" class="layout-interactive-tab">
				<div style="display: flex; justify-content: center; flex-direction: column">
					<span style="font-size: 12px; color: aliceblue; margin-bottom: 3px">
						<i style="font-size: 0.8rem" class="pi pi-globe"></i>
						Portale @if(sel_portali.length > 1){
						<i style="font-size: 0.8rem; float: right" class="pi pi-angle-down"></i>
						}
					</span>
					<span style="font-size: 13px; color: aliceblue">
						{{ active_portal_name }}
					</span>
				</div>
				@if(sel_portali.length > 1){
				<p-select [options]="sel_portali" [filter]="sel_portali.length > 5 ? true : false" [(ngModel)]="sel_portale" optionLabel="pt_descrizione" class="transparent-select" (onChange)="selectPortale()">
					<ng-template #dropdownicon> </ng-template>
				</p-select>
				}
			</div>
			} -->@if(active_company_name){
			<div id="company_selection" class="layout-interactive-tab">
				<div style="display: flex; justify-content: center; flex-direction: column">
					<span style="font-size: 12px; color: aliceblue; margin-bottom: 3px">
						<i style="font-size: 0.8rem" class="pi pi-building"></i>
						Azienda @if(totalCompanies > 1){
						<i style="font-size: 0.8rem; float: right" class="pi pi-angle-down"></i>
						}
					</span>
					<span style="font-size: 13px; color: aliceblue">
						{{ active_company_name }}
					</span>
				</div>
				@if(totalCompanies > 1){
				<p-select [options]="sel_companies" (onFilter)="onComapnyFilterChange($event)" [filter]="true" [(ngModel)]="sel_company" optionLabel="name" class="transparent-select" panelStyleClass="header-select-panel" (onChange)="selectCompany()">
					<ng-template #dropdownicon> </ng-template>
				</p-select>
				}
			</div>
			} @if(active_user_name && configService.isUserSuperAdmin()){
			<div id="user_selection" class="layout-interactive-tab">
				<div style="display: flex; justify-content: center; flex-direction: column">
					<span style="font-size: 12px; color: aliceblue; margin-bottom: 3px">
						<i style="font-size: 0.8rem" class="pi pi-users"></i>
						User @if(totalUsers > 1){
						<i style="font-size: 0.8rem; float: right" class="pi pi-angle-down"></i>
						}
					</span>
					<span style="font-size: 13px; color: aliceblue">
						{{ active_user_name }}
					</span>
				</div>
				@if(totalUsers > 1){
				<p-select [options]="sel_users" (onFilter)="onUserFilterChange($event)" [filter]="true" [(ngModel)]="sel_user" optionLabel="usr_username" class="transparent-select" panelStyleClass="header-select-panel" (onChange)="selectUser()">
					<ng-template #dropdownicon> </ng-template>
				</p-select>
				<!-- se eseiste currentuseradmin  metto un pulsante che lo ripristina -->
				}
			</div>
			@if(currentUserAdmin && configService.isUserSuperAdmin()){
			<div style="margin-top: 8px; text-align: center">
				<button type="button" class="btn btn-outline-primary" (click)="restoreAdmin()"><i class="pi pi-undo"></i> Ripristina Admin</button>
			</div>
			} }
		</div>
		<div class="topbar-actions" style="min-width: 200px; display: flex; align-items: center; gap: 12px;">
			@if(showChat) {
			<button type="button" class="notification-bell" (click)="goToMessaging()" title="Messaggi">
				<i class="pi pi-comments" style="font-size: 1.2rem; color: white;"></i>
				@if(unreadMessagesCount > 0) {
				<span class="notification-badge">{{ unreadMessagesCount > 99 ? '99+' : unreadMessagesCount }}</span>
				}
			</button>
			}
			@if(showNotifications) {
			<button type="button" class="notification-bell" (click)="goToNotifications()" title="Notifiche">
				<i class="pi pi-bell" style="font-size: 1.2rem; color: white;"></i>
				@if(unreadCount > 0) {
				<span class="notification-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
				}
			</button>
			}
			<div class="topbar-profile" style="position: relative">
				<button type="button" class="topbar-profile-button" (click)="op.toggle($event)" [class.active]="false">
					<span class="profile-details">
						<span class="profile-name">{{ this.configService.getUser().usr_firstname }} {{ this.configService.getUser().usr_lastname }}</span>
					</span>
					<p-avatar [label]="configService.getUsernameInitials()" styleClass="ml-2 user-avatar" shape="circle" [style]="{ background: configService.getColorFromDisplayName() }"> </p-avatar>
				</button>

				<p-popover #op styleClass="header-popover">
					<div (click)="op.hide()">
						<ul class="nav">
							<li class="nav-item w-full">
								<a (click)="goToProfile()" class="pl-1 nav-link nav-dropdown-toggle"><i class="pi pi-user"></i><span>Mio Profilo</span></a>
							</li>
							<li class="nav-item w-full">
								<a (click)="changeLanguage()" class="pl-1 nav-link nav-dropdown-toggle"><i class="pi pi-language"></i><span>Cambia Lingua</span></a>
							</li>
							<li class="nav-item w-full">
								<a (click)="changePortal()" class="pl-1 nav-link nav-dropdown-toggle"><i class="pi pi-cog"></i><span>Cambia Portale</span></a>
							</li>
							<li class="nav-item w-full">
								<a (click)="signOut()" class="pl-1 nav-link nav-dropdown-toggle"><i class="pi pi-power-off"></i><span>Esci</span></a>
							</li>
						</ul>
					</div>
				</p-popover>
			</div>
		</div>
	</div>
</div>

<ng-template #changeLanguageModal>
	<div class="language-selector">
		<div class="flex flex-wrap gap-4">
			<div class="flex items-center">
				<p-radiobutton name="language" value="it" [(ngModel)]="language" inputId="sel_italiano" />
				<label for="sel_italiano" class="ml-2">Italiano</label>
			</div>

			<div class="flex items-center">
				<p-radiobutton name="language" value="en" [(ngModel)]="language" inputId="sel_english" />
				<label for="sel_english" class="ml-2">English</label>
			</div>
		</div>
	</div>
</ng-template>
